/**
 * @author caijianjia
 * @date 2020/3/29 2:32 下午
 */

export const recordHead = [{
  prop: 'status',
  label: '状态',
  width: '180'
}, {
  prop: 'created_at',
  label: '操作时间',
  width: '180'
}, {
  prop: 'mobile',
  label: '操作账号'
},
// , {
//   prop: 'amount',
//   label: '金币费用'
// }
{
  prop: 'name',
  label: '操作人'
}, {
  prop: 'result_attr_id',
  label: '版本'
}, {
  prop: 'operation',
  label: '操作',
  width: '180'
}]
